// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"05e446a6","475":"5403a3b7","787":"d16d0675","861":"afc7d6a6","975":"2080eb1f"}[chunkId] + ".chunk.js";
};